import { render } from "./TendenciasComp.vue?vue&type=template&id=1cfb8964&scoped=true"
import script from "./TendenciasComp.vue?vue&type=script&lang=js"
export * from "./TendenciasComp.vue?vue&type=script&lang=js"

import "./TendenciasComp.vue?vue&type=style&index=0&id=1cfb8964&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cfb8964"]])

export default __exports__